import { ProfileMenuDto } from 'src/app/core/data-models/resource.data-models';
import { ResourceDataService } from './../../../core/data-services/resource/resource-data.service';
import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';
import { TenantConfigService } from '../../services/tenant-config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
baseUrl='faq/';
menus:ProfileMenuDto[]=[];
logoUrl:string='';
googlePlayDownloadUrl:string='';
appleStoreDownloadUrl:string='';
twitterUrl:string='';
linkedinUrl:string='';
constructor(
private resourceDataService:ResourceDataService,
public languageService:LanguageService,
private tenantConfigService: TenantConfigService,
){
  this.logoUrl=this.tenantConfigService.tenant.coloredLogoUrl;
  this.googlePlayDownloadUrl=this.tenantConfigService.tenant.googlePlayDownloadUrl;
  this.appleStoreDownloadUrl=this.tenantConfigService.tenant.appleStoreDownloadUrl;
  this.twitterUrl=this.tenantConfigService.tenant.twitterUrl;
  this.linkedinUrl=this.tenantConfigService.tenant.linkedinUrl;
}

ngOnInit(): void {
  this.resourceDataService.GetProfileMenu().subscribe({
    next:(res)=>{
     this.menus= res;
    }
  })
}

}
